import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home/Home";
import App from "../App";
import { StatusContextProvider } from "../store/StatusContextProvider";
import Checking from "../pages/Checking/Checking";
import { ROUTES } from "./routes";
import DialogContextProvider from "../store/DialogContextProvider";

const routes = createBrowserRouter([
  {
    path: ROUTES.home,
    element: <App />,
    children: [
      { path: ROUTES.home, element: <Home /> },
      {
        path: ROUTES.checking,

        element: (
          <StatusContextProvider>
            <DialogContextProvider>
              <Checking />
            </DialogContextProvider>
          </StatusContextProvider>
        ),
      },
    ],
  },
]);

export default routes;
